<template>
    <GZ-ModalMainTmpl icon="icon-clipboard" :overflow="false">
        <span slot="title">Изменить дату следующей проверки</span>

        <section slot="content">
            <gz-input-container 
                label="Укажите дату"
                class="gz-filter__item display-iblock w-auto"  
                :required="true"
                :valid="nextCheckupDate.valid"
                :validationMessage="nextCheckupDate.validationMessage"
            >
                <GZ-DateInput 
                    @dateValue="nextCheckupDate.value = $event" 
                    :value="nextCheckupDate.value"
                    type="datetime"
                    class="gz-date-input_no-border gz-date-input_calend-up"
                />
            </gz-input-container>
        </section>

        <section slot="actions">
            <GZ-BaseButton
                value="изменить дату"
                class="gz-button gz-button_default" 
                icon="icon-checkmark"
                @click="saveCheckupDate"
            />
        </section>
    </GZ-ModalMainTmpl>
</template>

<script>
export default {
    name: 'NextCheckupDateModal',

    props: {
        data: Object
    },
    data() {
        return {
            nextCheckupDate: {
                value: '',
                valid: true,
                validationMessage: ''
            }
        }
    },
    methods: {
        validation() {
            let errors = 0
            //Empty fields

            //Не пустое
            if (!this.isEmpty(this.nextCheckupDate.value)) {
                this.formValidationUtil(this.nextCheckupDate, false, this.$store.getters['validationMessages'].isEmtpy)
                errors++
            } else {
                this.formValidationUtil(this.nextCheckupDate, true, '')
            }

            //Notification
            return this.validationNotification(errors)
        },
        saveCheckupDate() {
            if (this.validation()) {
                const nextCheckupDate = this.nextCheckupDate.value.toISOString().split('.')[0]

                if (this.data.type === 'building') {
                    let building = this.$store.getters['addressesBuilding']
                    
                    building.attributes.nextCheckupDate = nextCheckupDate
                    
                    this.$store.dispatch('addressesEditBuilding', building)
                        .then(() => {
                            this.$store.dispatch('modalClose')
                        })
                        .catch(err => {
                            console.error('Ошибка при сохранении даты проверки здания: ', err)
                        })
                }
                if (this.data.type === 'shelter') {
                    let shelter = this.$store.getters['addressesShelter']
                    
                    shelter.attributes.nextCheckupDate = nextCheckupDate
                    
                    this.$store.dispatch('addressesEditShelter', shelter)
                        .then(() => {
                            this.$store.dispatch('modalClose')
                        })
                        .catch(err => {
                            console.error('Ошибка при сохранении даты проверки помещения: ', err)
                        })                
                }
            }
        } 
    }
}
</script>